const venues = [
  'ANC Caucus',
  'Batandwa Ndondo',
  'Dolly Mzaidume',
  'Joe Gqabi',
  'Magdeline Resha',
  'Management Boardroom',
  'Molly Blackburn',
  'Noninzi Luzipo',
  'Raymond Mhlaba Chamber',
  'Speakers Boardroom',
  'TBA',
  'Virtual',
  'Wilton Mkwayi',
];

export default venues;
